<template>
  <fragment>
    <default-header :h2="$t('myAccount.title')"></default-header>
    <back-btn></back-btn>
    <div class="innerContent">
      <input-standard
        :valueFromParent="user.garage ? changeStringToUpperCase(user.garage.country) : false"
        :disabled="true"
        :label="$t('general.cuntry')"
      />
      <input-standard
        :valueFromParent="user.language"
        :disabled="true"
        :label="$t('general.language')"
      />

      <h3 class="text-center mt-3 mb-3">{{$t('myAccount.personalDetails')}}</h3>

      <input-standard :valueFromParent="user.name" :disabled="true" :label="$t('general.name')" />

      <input-standard
        :valueFromParent="user.last_name"
        :disabled="true"
        :label="$t('general.lastName')"
      />

      <input-standard
        :valueFromParent="user.email"
        :disabled="true"
        :label="$t('general.enterEmail')"
      />

      <input-standard
        :valueFromParent="user.phone"
        :disabled="true"
        :label="$t('general.telephone')"
      />

      <h3 class="text-center mt-3 mb-3">{{$t('myAccount.GarageDetails')}}</h3>

      <input-standard
        :valueFromParent="user.garage ? user.garage.company_name : false"
        :disabled="true"
        :label="$t('myAccount.companyName')"
      />

      <input-standard
        :valueFromParent="user.garage ? user.garage.street : false"
        :disabled="true"
        :label="$t('myAccount.street')"
      />

      <div class="row" style="flex-wrap: nowrap; margin: auto;">
        <input-standard
          :valueFromParent="user.garage ? user.garage.street_number : false"
          :disabled="true"
          :label="$t('general.number')"
        />

        <input-standard
          :valueFromParent="user.garage ? user.garage.zip : false"
          :disabled="true"
          :label="$t('general.postCode')"
        />
      </div>

      <input-standard
        :valueFromParent="user.garage ? user.garage.city : false"
        :disabled="true"
        :label="$t('general.city')"
      />

      <!--         
        <div class="additionalPaddingOnSides">
          <div class="dropdown dropdown-form-control disabled">
            <button type="button" class="dropdown-toggle" data-display="static">
              <span class="dropdown-name">{{'sdfsdfdsf' }}</span>
              <span class="dropdown-icon">
                <font-awesome-icon :icon="['fas', 'angle-down']" />
              </span>
            </button>
            <div class="dropdown-menu"></div>
          </div>
      </div>-->

      <h3 class="text-center mt-4">{{$t('myAccount.doYouHaveEbtTester')}}</h3>

      <div class="mb-2">
        <div class="icheck-material-exide">
          <input
            type="radio"
            id="tester-yes"
            disabled
            name="have-tester"
            :checked="user.has_tester === 1"
          />
          <label for="tester-yes">{{$t('general.yes')}}</label>
        </div>
      </div>
      <div class="mb-2">
        <div class="icheck-material-exide">
          <input
            type="radio"
            id="tester-no"
            disabled
            name="have-tester"
            :checked="user.has_tester === 0"
          />
          <label for="tester-no">{{$t('general.no')}}</label>
        </div>
      </div>

      <h3 class="text-center mt-4">{{$t('myAccount.changeData')}}</h3>

      <div class="my-3">
        <button 
          class="btn btn-sm btn-outline-danger w-100"
          @click="deleteUser"
        >{{ $t('myAccount.deleteAccount') }}</button>
      </div>

      <ClientDeleteModal :additionalText="$t('myAccount.removalConfirmation')" ref="deleteClientModal"/>
    </div>
    <bottom-navigation />
  </fragment>
</template>

<script>
import DefaultHeader from '../partials/DefaultHeader'
import BottomNavigation from '../partials/BottomNavigation'
import InputStandard from '../components/InputStandard'
import SelectStandard from '../components/SelectStandard'
import { HTTP } from '../http';
import BackBtn from '../components/BackBtn'
import ClientDeleteModal from '../components/ClientDeleteModal.vue'
import { mapActions } from 'vuex'

export default {
  name: 'MyAccount',
  components: {
    BottomNavigation,
    DefaultHeader,
    InputStandard,
    SelectStandard,
    BackBtn,
    ClientDeleteModal,
  },
  data() {
    return {
      user: {}
    }
  },
  async beforeMount() {
    const response = await HTTP.get('/api/user');
    this.user = response.data;

    this.$children.forEach(component => {
      component.$forceUpdate();
    });
  },
  methods: {
    ...mapActions(['logoutAction']),
    changeStringToUpperCase(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    async deleteUser() {
      await this.$refs.deleteClientModal.open()

      HTTP.delete('/api/user')
      .then(() => this.logoutAction())
      .catch(() => this.$toasted.show(this.$i18n.t('errors.generic')))
    },
  }
};
</script>

<style lang="scss" scoped>
.dropdown-form-control {
  margin-bottom: 24px;
  border: 1px solid #ededed;

  &.disabled {
    background-color: #e9ecef;
  }

  ::-webkit-scrollbar {
    display: block !important;
  }

  ::-webkit-scrollbar {
    display: block !important;
  }

  ::-webkit-scrollbar {
    width: 10px !important;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: white !important;
    border-radius: 5px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #888 !important;
    border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555 !important;
  }

  button {
    outline: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0;
    .dropdown-name {
      padding: 0.375rem 0 0.375rem 0.75rem;
    }
    .dropdown-icon {
      background: #ededed;
      width: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0 1.1rem 1.1rem 0;
      height: 36px;
      margin-right: -0.3px;
    }
  }

  .dropdown-menu.show {
    width: 100.5%;
    left: -1px !important;
    margin-top: 0px;
    overflow-y: auto;
    max-height: 200px;
    border: 1px solid #ededed;
  }

  &.show {
    outline: none;
    border-radius: 1.1rem 1.1rem 0 0;
    .dropdown-icon {
      svg {
        transform: rotate(180deg);
      }
    }
  }
}
</style>